import { render, staticRenderFns } from "./billPaymentDetail.vue?vue&type=template&id=07d334fa&"
import script from "./billPaymentDetail.vue?vue&type=script&lang=js&"
export * from "./billPaymentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d334fa')) {
      api.createRecord('07d334fa', component.options)
    } else {
      api.reload('07d334fa', component.options)
    }
    module.hot.accept("./billPaymentDetail.vue?vue&type=template&id=07d334fa&", function () {
      api.rerender('07d334fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/BillPayment/siRui/billPaymentDetail.vue"
export default component.exports